import React, { useState } from "react";
import { X, Apple } from "lucide-react";
import { isNativeApp } from "../lib/platform";
import { useTablet } from "../hooks/useTablet";

const STORE_URL = "https://apps.apple.com/kz/app/angiolini-vip-club/id6820985524?l=ru";
const DISMISS_KEY = "ang_appstore_banner_dismissed";

// iPhone/iPad в браузере. iPadOS 13+ отдаёт десктопный UA «Macintosh» с тач-экраном.
const isIosBrowser = () => {
  if (isNativeApp()) return false;
  const ua = navigator.userAgent || "";
  const ipad = /Macintosh/.test(ua) && (navigator.maxTouchPoints || 0) > 1;
  return (/iPhone|iPad|iPod/.test(ua) || ipad) && !window.MSStream;
};

export default function AppStoreBanner() {
  const { tablet } = useTablet();
  const [hidden, setHidden] = useState(() => {
    try { return localStorage.getItem(DISMISS_KEY) === "1"; } catch { return false; }
  });
  if (hidden || !isIosBrowser()) return null;
  const close = () => {
    try { localStorage.setItem(DISMISS_KEY, "1"); } catch { /* приватный режим */ }
    setHidden(true);
  };
  return (
    <div data-testid="appstore-banner" style={{
      position: "fixed", bottom: "calc(64px + env(safe-area-inset-bottom, 0px))",
      left: "50%", transform: "translateX(-50%)", width: "100%",
      maxWidth: tablet ? "720px" : "430px", zIndex: 45, padding: "0 10px 8px",
      boxSizing: "border-box", pointerEvents: "none",
    }}>
      <div style={{
        pointerEvents: "auto", display: "flex", alignItems: "center", gap: "10px",
        background: "var(--ang-card, rgba(255,255,255,0.92))",
        border: "1px solid var(--ang-gold)", borderRadius: "14px",
        padding: "10px 10px 10px 12px",
        boxShadow: "0 8px 24px rgba(74,20,16,0.14)",
        backdropFilter: "blur(10px)",
      }}>
        <Apple size={20} style={{ color: "var(--ang-text)", flexShrink: 0 }} aria-hidden="true" />
        <span style={{ flex: 1, minWidth: 0, fontFamily: "Manrope", fontSize: "12px",
          lineHeight: 1.35, color: "var(--ang-text)" }}>
          ANGIOLINI VIP CLUB — каталог и цены в приложении
        </span>
        <a href={STORE_URL} target="_blank" rel="noopener noreferrer"
          data-testid="appstore-banner-download"
          style={{ flexShrink: 0, background: "var(--ang-gold)", color: "#1A1A1A",
            textDecoration: "none", fontFamily: "Manrope", fontSize: "11px", fontWeight: 800,
            letterSpacing: "0.04em", textTransform: "uppercase", padding: "8px 10px",
            borderRadius: "999px", whiteSpace: "nowrap" }}>
          Скачать в App Store
        </a>
        <button onClick={close} aria-label="Закрыть баннер" data-testid="appstore-banner-close"
          style={{ flexShrink: 0, background: "transparent", border: "none", cursor: "pointer",
            color: "var(--ang-text)", opacity: 0.6, padding: "4px", lineHeight: 0 }}>
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
